/**
 * Floor for a model's self-reported confidence (cloud, offline upgrade,
 * on-device). Not comparable to the keyword floor, which a deterministic
 * match earns: the prompt calibrates the model to ≥ 0.9 when it
 * recognises the title, 0.7-0.85 when it infers, below 0.7 when it guesses.
 * The cloud is the last tier, so a guess must become no answer rather
 * than a chip — and never a shared cache row.
 */
export const CLOUD_MIN_CONFIDENCE = 0.7;
